<template>
  <div class="menu-page col-md-6 offset-md-3">
    <div class="container page">
      <form @submit.prevent="onSubmit(currentUser.account)">
        <fieldset :disabled="inProgress">
            <hr>
          <fieldset v-for="(meal, index) in menu.menuMeal" :key="index">
            <button
              @click="delMeal(index)"
              class="btn btn-sm btn-outline-danger offset-md-10 mb-3 float-right"
              type="button"
            >刪除</button>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">餐點名稱</span>
              </div>
              <input type="text" class="form-control" v-model="meal.name" placeholder="請輸入" />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">描述</span>
              </div>
              <input type="text" class="form-control" v-model="meal.description" placeholder="請輸入" />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">價格</span>
              </div>
              <input
                type="number"
                class="form-control"
                v-model.number="meal.price"
                placeholder="請輸入"
              />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">庫存</span>
              </div>
              <input
                type="number"
                class="form-control"
                v-model.number="meal.inventory"
                placeholder="請輸入"
              />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">狀態</span>
              </div>
              <select class="custom-select" v-model="meal.status">
                <option value=show>顯示</option>
                <option value=hide>隱藏</option>
              </select>
            </div>
            <hr>
          </fieldset>
          <button @click="addMeal()" class="btn btn-sm btn-secondary" type="button">增加餐點</button>
        </fieldset>
        <hr>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">最小金額</span>
          </div>
          <input
            type="number"
            class="form-control"
            v-model.number="menu.minPrice"
            placeholder="請輸入"
          />
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">開放點餐</span>
          </div>
          <select class="custom-select" v-model="menu.status">
            <option value="on">開放</option>
            <option value="off">關閉</option>
          </select>
        </div>
        <hr />
        <button :disabled="inProgress" class="btn btn-block btn-secondary" type="submit">確定</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  name: "MenuEdit",
  methods: {
    onSubmit(slug) {
      let action = slug ? "menuEdit" : "menuCreate";
      this.$store.dispatch(action);
    },
    addMeal() {
      store.dispatch("mealAdd");
    },
    delMeal(index) {
      store.dispatch("mealDel", index);
    }
  },
  async beforeRouteEnter(to, from, next) {
    store.dispatch("fetchMenu", to.params.slug);
    return next();
  },
  data() {
    return {
      inProgress: false,
      errors: {}
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["menu", "currentUser"])
  }
};
</script>
